import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { isDraftAssistantFrontierEnabled } from './isDraftAssistantFrontierEnabled';
import { isAIX00User } from 'owa-copilot-settings-store';
import { getApplicationSettings } from 'owa-application-settings';
import hasM365CopilotLicense from './hasM365CopilotLicense';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import isMChatEnabled from './isMChatEnabled';
import { logGreyError } from 'owa-analytics';

let hasLogged = false;
export function isDraftAssistantEnabled(mailboxInfo: MailboxInfo): boolean {
    // Coauthoring requires chat
    if (!isMChatEnabled(mailboxInfo)) {
        return false;
    }

    // for AIX00 users, we want to scope them specifically as they are special group of users
    // who help with early feedback.
    const isEnabled =
        (isAccountFeatureEnabled('mon-copilot-draft-assistant', mailboxInfo) &&
            hasM365CopilotLicense(mailboxInfo)) ||
        isDraftAssistantFrontierEnabled(mailboxInfo) ||
        (isAIX00User(mailboxInfo) &&
            getApplicationSettings('CopilotAIX00', mailboxInfo).draftAssistantEnabled);

    // Temporary sanity check in preparation for switching over to OCS
    if (
        !hasLogged &&
        isEnabled &&
        !isCopilotFeatureEnabled('MailCoauthoring', mailboxInfo, true /*skipLanguageCheck*/)
    ) {
        logGreyError('CoauthNotEnabledOCS', mailboxInfo, undefined /*error*/, {
            isFrontier: isDraftAssistantFrontierEnabled(mailboxInfo),
        });
        hasLogged = true;
    }

    return isEnabled;
}
